import React from 'react';

const TermsOfService = () => {
  return (
    <div className="bg-gray-100 font-sans text-gray-800">
      <div className="max-w-4xl mx-auto my-12 px-4 py-6 bg-white shadow-lg rounded-lg">
        <header className="text-center mb-8">
          <h1 className="text-3xl font-semibold text-gray-900">Terms of Service for "Wait, When's Your Birthday"</h1>
          <p className="text-sm text-gray-600">Last Updated: January 29, 2025</p>
        </header>

        <section className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-blue-600">1. Introduction</h2>
            <p>Welcome to <strong>"Wait, When's Your Birthday" (WWYB)</strong>, a service that allows users to connect with friends and track important birthdays. By accessing or using our platform, you agree to comply with and be bound by the following Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our service.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">2. Eligibility</h2>
            <p>To use WWYB, you must be at least 13 years of age or the age of majority in your jurisdiction. By using our platform, you represent that you meet these age requirements. If you are under 18, you must have permission from a parent or guardian to use WWYB.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">3. Account Registration</h2>
            <p>To create an account, you must provide accurate and complete information, including your name, email address, and a password. You are responsible for keeping your account details confidential and for all activity under your account. Notify us immediately if you suspect any unauthorized use of your account.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">4. User Conduct</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-8 space-y-2">
              <li>Use WWYB for lawful purposes and in a way that does not violate the rights of others or restrict their ability to use the service.</li>
              <li>Not upload or transmit harmful content, such as viruses, malware, or illegal material.</li>
              <li>Respect other users' privacy and not share their information without consent.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">5. User-Generated Content</h2>
            <p>WWYB allows users to share and store data such as birthdates, profile pictures, and messages. By uploading or submitting content to our platform, you grant WWYB a non-exclusive, royalty-free, worldwide license to use, display, and distribute your content in accordance with our <a href="/privacy" className="text-blue-500 hover:underline">Privacy Policy</a>.</p>
            <p>You are responsible for all content you upload or share and agree not to post content that:</p>
            <ul className="list-disc pl-8 space-y-2">
              <li>Infringes on intellectual property or privacy rights.</li>
              <li>Is harmful, threatening, or discriminatory.</li>
              <li>Violates any applicable law.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">6. Privacy and Data Collection</h2>
            <p>We value your privacy. By using WWYB, you consent to the collection, storage, and use of your personal data as described in our <a href="/privacy" className="text-blue-500 hover:underline">Privacy Policy</a>. This includes data you provide when registering for an account and interacting with other users on the platform.</p>
            <p>We may also use cookies and similar technologies to improve your experience. You can manage your cookie preferences through your browser settings.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">7. Service Availability and Changes</h2>
            <p>We strive to ensure the availability of WWYB. However, we cannot guarantee that the service will be uninterrupted or error-free. We reserve the right to modify, suspend, or terminate WWYB at any time without prior notice.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">8. Termination</h2>
            <p>We may suspend or terminate your account if you violate these Terms or engage in unlawful activity. Upon termination, you will lose access to your account and any content associated with it.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">9. Disclaimers and Limitation of Liability</h2>
            <p>WWYB is provided "as is," and we make no warranties or representations regarding the accuracy or completeness of the service. We are not liable for any indirect, incidental, or consequential damages resulting from your use of WWYB, including loss of data or profits.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">10. Indemnification</h2>
            <p>You agree to indemnify and hold WWYB and its affiliates harmless from any claims, damages, or losses arising out of your use of the service or violation of these Terms.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">11. Modifications to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. We will notify you of significant changes via email or through the platform. Your continued use of WWYB after the changes have been posted constitutes your acceptance of the updated Terms.</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">12. Governing Law and Dispute Resolution</h2>
            <p>These Terms are governed by the laws of New York. Any disputes arising out of these Terms or the use of WWYB will be resolved through binding arbitration in accordance with the rules of the American Arbitration Association (AAA).</p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-blue-600">13. Contact Information</h2>
            <p>For any questions or concerns regarding these Terms, please contact us at:</p>
            <p className="text-blue-500">Email: <a href="mailto:support@waitwhensyourbirthday.com">support@waitwhensyourbirthday.com</a></p>
          </div>
        </section>

        <footer className="mt-12 text-center text-sm text-gray-600">
          <p>By using or accessing WWYB, you agree to these Terms of Service.</p>
        </footer>
      </div>
    </div>
  );
}

export default TermsOfService;
